<template>
    <div class="footer">
    </div>
</template>

<script>
export default {
    name: 'myFooter',
}
</script>

<style lang="stylus" scoped>
    .footer {
        background: #24292e;
        width: 100%;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center; 
    }
</style>